import { SetOfDayTypesAPI } from '../../../api/bussched/SetOfDayTypesAPI';

export class SetOfDayTypesCommand {
    list(successCallback, errorCallback) {
        const apiResult = SetOfDayTypesAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Tipos de Dia");
            }
        });
    }

    listFull(successCallback, errorCallback) {
        const apiResult = SetOfDayTypesAPI.listFull();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Tipos de Dia");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/SetOfDayTypesCommand.js